"use strict";
const { object, string, number, array } = require('../utils/modifiedYup');
const { displayComponentSchema, formComponentSchema, } = require('../commonSteps/componentSchema');
const { builderContentSchema, } = require('../taskSteps/sendMessageSchema/contentSchema');
const formContentSchema = object().oneOfSchemas([
    builderContentSchema,
    object()
        .shape({
        components: array()
            .oneOfSchemas([displayComponentSchema, formComponentSchema])
            .required(),
    })
        .required(),
]);
exports.formTriggerSchema = object().shape({
    id: number().required(),
    type: string().oneOf(['form']).required(),
    data: object()
        .shape({
        form: formContentSchema,
    })
        .required(),
});
//# sourceMappingURL=formTriggerSchema.js.map